import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { SrIcon } from "@/components/ui/SrIcon";

export interface StorageCaptureState {
  gb: string;
  location: string;
}

/**
 * VIB-1308: fanger lagret GB + lokasjon ved prosjektlukking. Feltet er
 * FRIVILLIG og blokkerer IKKE lukking (Clean 4:2:2-mønsteret). Er GB satt
 * (> 0) og prosjektet har en kunde, oppretter lukkeflyten en storage-avtale
 * med 12 mnd inkludert lagring. Uten kunde kan avtalen ikke opprettes.
 */
export function ClosingStorageSection({
  value,
  onChange,
  hasCustomer,
}: {
  value: StorageCaptureState;
  onChange: (next: StorageCaptureState) => void;
  hasCustomer: boolean;
}) {
  return (
    <div className="rounded border border-gray-200 bg-white px-3 py-2.5 space-y-2.5">
      <div className="flex items-center gap-2 text-sm">
        <SrIcon name="database" className="w-4 h-4 text-muted-foreground" />
        <span>Lagring av råmateriale (frivillig)</span>
      </div>
      <p className="text-xs text-muted-foreground">
        12 måneder lagring er inkludert fra lukkedato. Etter det faktureres lagring etter kundens totale lagrede GB.
      </p>
      <div className="grid grid-cols-2 gap-2">
        <div className="space-y-1">
          <Label htmlFor="closing-storage-gb" className="text-xs">Antall GB</Label>
          <Input
            id="closing-storage-gb"
            type="number"
            min={0}
            value={value.gb}
            onChange={(e) => onChange({ ...value, gb: e.target.value })}
            placeholder="0"
            aria-label="Antall GB lagret"
          />
        </div>
        <div className="space-y-1">
          <Label htmlFor="closing-storage-location" className="text-xs">Lagringslokasjon</Label>
          <Input
            id="closing-storage-location"
            value={value.location}
            onChange={(e) => onChange({ ...value, location: e.target.value })}
            placeholder="F.eks. NAS / arkiv"
            aria-label="Lagringslokasjon"
          />
        </div>
      </div>
      {!hasCustomer && Number(value.gb) > 0 && (
        <div className="text-xs text-amber-800 bg-amber-50 rounded px-2 py-1.5 border border-amber-200 flex items-start gap-1.5">
          <SrIcon name="alert-triangle" className="w-3.5 h-3.5 mt-0.5 shrink-0" />
          <span>Prosjektet mangler kunde — lagringsavtale kan ikke opprettes. Legg til kunde under Detaljer først.</span>
        </div>
      )}
    </div>
  );
}
